<template>
  <div class="counterSystem">
    <div>
      <el-tabs v-model="activeName" class="demo-tabs" @tab-click="handleClick">
        <el-tab-pane v-for="(item,index) in menus" :key="index" :name="item.name" :label="item.label"/>
      </el-tabs>
    </div>
    <div class="over-main">
      <router-view/>
    </div>
  </div>
</template>

<script>

export default {
  name: 'DbConfig',
  watch: {
    $route: {
      immediate: true,
      handler(newVal, oldVal) {
        this.act = newVal.path;
        const path = newVal.path;
        this.menus.forEach(item => {
          if (path.endsWith(item.name)) {
            this.activeName = item.name;
          }
        })
      },
    }
  },
  data() {
    return {
      activeName: 'databaseNav',
      menus: [
        {
          name: 'databaseNav',
          label: '数据库导航'
        }
      ]
    }
  },
  created() {

  },
  methods: {
    handleClick(tab, event) {
      this.$router.push("/monitoringPanel/counterSystem/" + tab.props.name)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.counterSystem {
  //padding: 20px;
}

::v-deep(.el-tabs__header) {
  margin: 0;
}
</style>
